export default __webpack_public_path__ + "static/media/coin6.8c90f3e4.png";